module.exports = __webpack_public_path__ + "static/media/no-messages-dark.8b435a94.png";